import React from "react";

import { PartStatus } from "../../helpers/parts";

const PartProgress = ({ part }) => {
  const milestones = [10, 20, 40, 50];

  return (
    <div>
      <div className="level dot-progress mb-4">
        <div className="progress-bg"></div>
        {milestones.map((dot) => (
          <div key={dot} className="level-item">
            <div
              className={"dot " + (dot <= part.status ? "is-success" : "")}
              title={PartStatus[dot].label}
            ></div>
          </div>
        ))}
      </div>
      <span>{PartStatus[part.status].label}</span>
    </div>
  );
};

export default PartProgress;
